<template>
  <div class="changePas" :style="{ height: winh + 'px' }">
    <div class="top">
      <span class="icon" @click="goback"></span>
      <span class="title">修改登录密码</span>
    </div>

    <div class="textBox">
      <ul>
        <li>
          <span>原密码</span>
          <input
            type="text"
            name=""
            id=""
            placeholder="请输入密码"
            v-model="values.oldpass"
          />
        </li>
        <li>
          <span>新密码</span>
          <input
            type="text"
            name=""
            id=""
            placeholder="请输入密码"
            v-model="values.newpass"
          />
        </li>
        <li>
          <span>确认新密码</span>
          <input
            type="text"
            name=""
            id=""
            placeholder="请输入密码"
            class="active"
            v-model="values.snewpass"
          />
        </li>
      </ul>
    </div>

    <span class="txt">*请格密码设定 为8位大小写字母与数宅的组合</span>

    <div class="sureBt">
      <button
        @click="sureFn"
        :disabled="values.oldpass.replace(/\s*/g, '').length === 0 || values.newpass.replace(/\s*/g, '').length === 0 || values.snewpass.replace(/\s*/g, '').length === 0"
        :class="values.oldpass.replace(/\s*/g, '').length === 0 || values.newpass.replace(/\s*/g, '').length === 0 || values.snewpass.replace(/\s*/g, '').length === 0 ? '' : 'active'"
      >确认
      </button>
    </div>
  </div>
</template>

<script>
import { Toast } from "vant"
import Vue from 'vue'
import agent from '@/agents/auth'
export default Vue.extend({
  name: "changePas",
  data() {
    return {
      winh: 0,
      values: {
        oldpass: '',
        newpass: '',
        snewpass: '',
      }
      
    };
  },
  created() {
    //背景图高度自适应
    let _this = this;
    this.winh = window.innerHeight;
    window.onresize = function () {
      _this.winh = window.innerHeight;
    };
  },
  methods: {
    sureFn() {
        this.changePassword()
    },
    async changePassword(){
        const { ok, message } = await agent.change_password(this.values)
        if (!ok) {
            Toast({
                message: message,
                duration: 1000,
                overlay: false,
            });
        } else {
            Toast({
                message: "密码修改成功！",
                duration: 1000,
                overlay: false,
            });
            this.$router.push({ name: "mySet" });
        }
    },
    goback() {
      this.$router.go(-1);
    },
  },
})
</script>

<style lang="scss" scoped>
.changePas {
  width: 100%;
  background-color: #f7f8f9;
  position: relative;
  overflow: hidden;
  .top {
    width: 100%;
    height: 56px;
    position: relative;
    margin-top: 24px;
    .icon {
      display: block;
      width: 25px;
      height: 25px;
      background-image: url("../assets/close.png");
      background-size: 25px 25px;
      position: absolute;
      left: 15px;
      top: 50%;
      margin-top: -12px;
    }
    .title {
      display: block;
      font-weight: 500;
      font-size: 16px;
      color: #23262f;
      text-align: center;
      line-height: 56px;
    }
  }
  .textBox {
    width: 100%;
    background-color: white;
    margin-top: 16px;
    ul {
      width: 100%;
      li {
        width: 100%;
        padding: 0px 0px 0px 32px;
        border-bottom: 1px solid rgb(230, 230, 230);
        box-sizing: border-box;
        height: 46px;
        display: flex;
        align-items: center;
        ::-webkit-input-placeholder {
          color: #bdbec1;
          font-size: 14px;
        }
        span {
          display: block;
          font-size: 14px;
          color: #50525b;
        }
        input {
          display: block;
          flex-grow: 1;
          flex-shrink: 0;
          height: 46px;
          border: none;
          font-size: 14px;
          padding-left: 48px;
          box-sizing: border-box;
          background-color: transparent;
        }
        .active {
          padding-left: 22px;
        }
      }
    }
  }
  .txt {
    display: block;
    font-size: 12px;
    color: #ee6236;
    padding-left: 32px;
    margin-top: 8px;
  }
  .sureBt {
    width: 100%;
    padding: 0px 30px;
    box-sizing: border-box;
    position: absolute;
    top: 85%;
    button {
      width: 100%;
      height: 52px;
      border: none;
      line-height: 52px;
      text-align: center;
      border-radius: 67px;
      font-size: 16px;
      background-color: #dcdde0;
      color: #ffffff;
      &.active {
        border-radius: 0px;
        background-color: #70b2ff;
      }
    }
  }
}
</style>